import { useState, useEffect } from 'react';
import { applicationAPI } from '../../services/api';

const ApplicationStatus = () => {
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadApplications();
    }, []);

    const loadApplications = async () => {
        try {
            const response = await applicationAPI.getMyApplications();
            setApplications(response.applications || []);
        } catch (err) {
            console.error('Failed to load applications:', err);
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (status) => {
        const colors = {
            draft: 'bg-gray-500',
            submitted: 'bg-blue-500',
            under_review: 'bg-yellow-500',
            interview_scheduled: 'bg-purple-500',
            selected: 'bg-green-500',
            rejected: 'bg-red-500',
            waitlisted: 'bg-orange-500'
        };
        return colors[status] || 'bg-gray-500';
    };

    if (loading) {
        return <div className="text-center py-8">Loading...</div>;
    }

    return (
        <div className="max-w-4xl mx-auto p-6">
            <h1 className="text-3xl font-bold mb-6">My Applications</h1>

            {applications.length === 0 ? (
                <div className="bg-gray-100 p-8 rounded-lg text-center">
                    <p className="text-gray-600 mb-4">You haven't submitted any applications yet.</p>
                    <a href="/apply" className="text-blue-600 hover:underline">
                        Start your application
                    </a>
                </div>
            ) : (
                <div className="space-y-4">
                    {applications.map((app) => (
                        <div key={app.id} className="bg-white p-6 rounded-lg shadow">
                            <div className="flex justify-between items-start mb-4">
                                <div>
                                    <h3 className="text-xl font-bold">{app.session_name}</h3>
                                    <p className="text-gray-600">Stage {app.stage} of 4</p>
                                </div>
                                <span className={`px-3 py-1 rounded text-white ${getStatusColor(app.status)}`}>
                                    {app.status.replace('_', ' ').toUpperCase()}
                                </span>
                            </div>
                            <div className="grid grid-cols-2 gap-4 text-sm">
                                <div>
                                    <span className="font-medium">Submitted:</span>{' '}
                                    {app.submitted_at ? new Date(app.submitted_at).toLocaleDateString() : 'Not submitted'}
                                </div>
                                <div>
                                    <span className="font-medium">Last Updated:</span>{' '}
                                    {new Date(app.updated_at).toLocaleDateString()}
                                </div>
                            </div>
                            {app.status === 'draft' && (
                                <div className="mt-4">
                                    <a
                                        href={`/apply?session=${app.session_id}`}
                                        className="text-blue-600 hover:underline"
                                    >
                                        Continue Application →
                                    </a>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ApplicationStatus;


